import { render, staticRenderFns } from "./PublicBoxMaskDialog.vue?vue&type=template&id=3ba37e24&scoped=true"
import script from "./PublicBoxMaskDialog.vue?vue&type=script&lang=js"
export * from "./PublicBoxMaskDialog.vue?vue&type=script&lang=js"
import style0 from "./PublicBoxMaskDialog.vue?vue&type=style&index=0&id=3ba37e24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba37e24",
  null
  
)

export default component.exports